/**
 * Permission modes configuration
 * Single source of truth for all permission structures across the app
 * Used by EditUserProfile.vue and PermissionPresets.vue
 */

const PERMISSION_MODES = [
  {
    key: 'admin',
    label: 'Admin Mode',
    sections: [
      {
        title: 'Site Permissions',
        items: [
          {
            key: 'admin.site.see',
            label: 'See all sites admin information',
          },
          {
            key: 'admin.site.edit_primary',
            label: 'Edit primary sites information',
          },
          {
            key: 'admin.site.edit_all',
            label: 'Edit all sites information',
          },
          { key: 'admin.site.create', label: 'Create/edit sites' },
        ],
      },
      {
        title: 'User Approvals & Roles',
        items: [
          {
            key: 'admin.approvals.approve_primary',
            label: 'Approve users to primary site',
          },
          {
            key: 'admin.approvals.edit_primary_roles',
            label: 'Edit primary sites users roles',
          },
          {
            key: 'admin.approvals.approve_all',
            label: 'Approve users to all sites',
          },
          {
            key: 'admin.approvals.edit_all_roles',
            label: 'Edit all sites users roles',
          },
          {
            key: 'admin.approvals.create_roles',
            label: 'Create/edit roles',
          },
        ],
      },
      {
        title: 'Instrumentation',
        items: [
          {
            key: 'admin.instrumentation.edit_primary',
            label: 'Edit primary sites instrumentation',
          },
          {
            key: 'admin.instrumentation.edit_all',
            label: 'Edit all sites instrumentation',
          },
          {
            key: 'admin.instrumentation.create_edit_types',
            label: 'Create/edit instrument types',
          },
        ],
      },
      {
        title: 'Power Admin',
        readonly: true,
        items: [
          {
            key: 'admin.approvals.grant_power',
            label: 'Grant Power Admin rights',
          },
          { key: 'admin.power.edit_fleet', label: 'Edit fleet data' },
          { key: 'admin.power.surrogate', label: 'Surrogate' },
          {
            key: 'admin.power.notification',
            label: 'Notification banner',
          },
        ],
      },
    ],
  },
  {
    key: 'editor',
    label: 'Editor Mode',
    items: [
      {
        key: 'editor.see_all_templates',
        label: 'See all templates (all sites)',
      },
      { key: 'editor.create_templates', label: 'Create templates' },
      { key: 'editor.edit_all_templates', label: 'Edit all templates' },
    ],
  },
  {
    key: 'publisher',
    label: 'Publisher Mode',
    items: [
      {
        key: 'publisher.see_all_jobs',
        label: 'See all primary and secondary site jobs',
      },
      { key: 'publisher.create_jobs', label: 'Create jobs' },
      { key: 'publisher.edit_all_jobs', label: 'Edit all visible jobs' },
    ],
  },
  {
    key: 'inspector',
    label: 'Inspector Mode',
    items: [
      {
        key: 'inspector.see_all_jobs',
        label: 'See all primary and secondary site jobs',
      },
      {
        key: 'inspector.edit_visible_jobs',
        label: 'Edit all visible jobs',
      },
      { key: 'inspector.leadman_signoff', label: 'Leadman sign off' },
    ],
  },
  {
    key: 'report',
    label: 'Report Mode',
    items: [
      {
        key: 'report.see_all_jobs',
        label: 'See all primary and secondary site jobs',
      },
      {
        key: 'report.edit_all_visible_jobs',
        label: 'Edit all visible jobs',
      },
      { key: 'report.engineering_review', label: 'Engineering review' },
      { key: 'report.download', label: 'Download report' },
      { key: 'report.push_globus', label: 'Push report to Globus' },
    ],
  },
];

export default PERMISSION_MODES;
